import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import {
  PAYMENT_OPTIONS_PAGE_ROUTE,
  PAYMENT_PAGE_FOR_CUSTOMER_ROUTE,
  POLICY_STATUS_ROUTE,
  THANK_YOU_PAGE_ROUTE,
} from "../routes";
import getSearchParamsWithLabels from "./Helpers/getSearchParamsgetSearchParamsWithLabels";
import { encrypt } from "../../Utilities/utils";

export const PayPerson = {
  CUSTOMER: "customer",
  POSP: "posp",
};

export const usePaymentStatusPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [searchParamLabels, setSearchParamLabels] = useState([]);
  const [loading, setLoading] = useState(false);

  const productName = searchParams?.get("product");
  const transferDataId = searchParams?.get("transferId"); // TODO: Not encrypted
  const transactionStatus = searchParams?.get("transactionStatus"); // It should be 'Success' or 'Failure'
  const payPerson = searchParams?.get("payPerson");

  const paymentFailed = transactionStatus !== "Success";

  useEffect(() => {
    // Create labels for search params to handle UI generic
    const searchParamsWithLabels = getSearchParamsWithLabels(
      productName,
      searchParams
    );
    setSearchParamLabels(searchParamsWithLabels);

    // Show success dialog
    if (transactionStatus !== "Success") {
      Swal.fire({
        icon: "error",
        title: "Your Transaction has Failed",
        position: "center",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      });
    }
  }, [transactionStatus, searchParams, productName]);

  const savePaymentDetailsAsPDF = (policyNumber) => {
    const input = document.getElementById("root");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(imgData, "JPEG", 10, 10, 180, 150);
      pdf.save(`Payment Details (${policyNumber}).pdf`);
    });
  };

  const handleOnBack = () => {
    navigate(-1);
  };

  const nextHandler = () => {
    // If payment failed
    if (paymentFailed) {
      // If customer is paying then navigate to payment page
      if (payPerson === PayPerson.CUSTOMER) {
        navigate(`${PAYMENT_PAGE_FOR_CUSTOMER_ROUTE}/${transferDataId}/`);
        return;
      }
      // If POSP is paying then navigate to previous page
      else if (payPerson === PayPerson.POSP) {
        const encryptedTransferDataId = encrypt(transferDataId);
        navigate(
          `${PAYMENT_OPTIONS_PAGE_ROUTE}/${encodeURIComponent(
            encryptedTransferDataId
          )}/`
        );
        return;
      }
    }

    // If customer is paying then save payment details as PDF
    if (payPerson === PayPerson.CUSTOMER) {
      const policyNumber = searchParams?.get("policyNo");
      savePaymentDetailsAsPDF(policyNumber);
      Swal.fire({
        icon: "success",
        title: "Payment Details is downloaded",
        position: "center",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          navigate(THANK_YOU_PAGE_ROUTE);
        }
      });
      return;
    }
    // If customer is not paying then navigate to policy status page
    let state = {};
    // Reliance IPA
    if (productName === "Reliance IPA") {
      const policyNumber = searchParams?.get("policyNo");
      const proposalNumber = searchParams?.get("proposalNo");
      state = {
        policyNumber,
        proposalNumber,
      };
    }

    navigate(`${POLICY_STATUS_ROUTE}/${transferDataId}/`, {
      state: state,
    });
  };

  return {
    searchParamLabels,
    transactionStatus,
    paymentFailed,
    payPerson,
    loading,
    handleOnBack,
    nextHandler,
  };
};
